module.exports = __webpack_public_path__ + "static/media/Group.1ea0572b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/Group.png
// module id = 385
// module chunks = 0